import React, { SVGProps } from 'react';

const LiveSupportIcon = (props: SVGProps<SVGSVGElement>) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 20 21"
			fill="none"
			width="100%"
			height="100%"
			{...props}
		>
			<path
				d="M18.4615 5.11538H15.3846V2.03846C15.3846 1.63044 15.2225 1.23912 14.934 0.950605C14.6455 0.662087 14.2542 0.5 13.8462 0.5H1.53846C1.13044 0.5 0.739122 0.662087 0.450605 0.950605C0.162087 1.23912 0 1.63044 0 2.03846V14.3462C0.000451647 14.4909 0.0417185 14.6325 0.11906 14.7548C0.196401 14.8772 0.306679 14.9752 0.437225 15.0376C0.567771 15.1001 0.713289 15.1245 0.857062 15.108C1.00083 15.0914 1.13703 15.0347 1.25 14.9442L4.61538 12.2308V15.1154C4.61538 15.5234 4.77747 15.9147 5.06599 16.2032C5.35451 16.4918 5.74582 16.6538 6.15385 16.6538H15.1529L18.75 19.5596C18.8861 19.6697 19.0557 19.7301 19.2308 19.7308C19.4348 19.7308 19.6304 19.6497 19.7747 19.5055C19.919 19.3612 20 19.1656 20 18.9615V6.65385C20 6.24582 19.8379 5.85451 19.5494 5.56599C19.2609 5.27747 18.8696 5.11538 18.4615 5.11538ZM4.09135 10.6712L1.53846 12.7356V2.03846H13.8462V10.5H4.575C4.39895 10.5 4.22823 10.5604 4.09135 10.6712ZM18.4615 17.351L15.9087 15.2865C15.7725 15.1764 15.6029 15.1161 15.4279 15.1154H6.15385V12.0385H13.8462C14.2542 12.0385 14.6455 11.8764 14.934 11.5879C15.2225 11.2993 15.3846 10.908 15.3846 10.5V6.65385H18.4615V17.351Z"
				fill="currentColor"
			/>
		</svg>
	);
};

export default LiveSupportIcon;
